import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";

export const CalendarDashboardGlobalApi = createApi({
  reducerPath: "calendarDashboardGlobalApi",
  baseQuery: customBaseQuery,
  tagTypes: ["events"],
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getAllEventsForGlobal: builder.query({
      query: (pageSize: number) => {
        return {
          url: `/event?pageSize=${pageSize}`,
          method: "GET"
        };
      },
      providesTags: ["events"]
    }),
    getSearchEventsForGlobal: builder.query({
      query: (body: any) => {
        return {
          url: `/search/calendar/trainingCalendar`,
          method: "POST",
          body: body
        };
      }
    })
  })
});

export const {
  useGetAllEventsForGlobalQuery,
  useGetSearchEventsForGlobalQuery
} = CalendarDashboardGlobalApi;
